import $ from 'jquery'
import EventBus from 'eventing-bus'
import Store from 'store2'

$(document).on("select2:open", () => {
    document.querySelector(".select2-container--open .select2-search__field").focus()
})


class Imdb {
    constructor() {
        this.cache = {}
        this.store = Store.namespace('imdb')
        window._imdb = this

        EventBus.on('imdb-clear', ()=> {
            this.clear()
            this.el.find('option').remove()
            this.start()
        })

        EventBus.on('imdb-selected', (data)=> {
            this.onSelected(data)
        })

        EventBus.on('imdb-preload', (data)=> {
            this.onPreload(data)
        })

        $(document).ready(()=> {
            this.start();
        })
    }

    clear() {
        this.store.clearAll()
        this.start()
        this.dispatchUpdate()
    }

    onSelected(selected) {
        console.debug('[imdb] selected', selected)
        this.selected = selected && selected.target || selected
        this.store.set('selected', this.selected)
        this.dispatchUpdate(this.selected)
    }

    dispatchUpdate(data) {
        const evt = new CustomEvent("imdb-update", data);
        window.dispatchEvent(evt)
    }

    onPreload() {
    }

    detailsFor(film) {
        let id = film.id || film
        let details = this.store.get(id)
        console.log('[imdb] details for:', id, details)

        if (!details) {
            console.log('[imdb] fetching remote details')
            $.get(`/imdb/details/${id}`, (data)=>{
                console.log('[imdb] RECEIVED details', id, data)
                if (data) {
                    this.store.set(id, data)
                    this.dispatchUpdate()
                }
            })
        }

        return details;
    }

    start() {
        this.el = $('#imdb-autocomplete')
        this.el.select2({
            placeholder: "Search for a title",
            language: {
                noResults: function (params) {
                    return "Enter a Film Title";
                }
            },

            templateResult: function (item) {
                let $span
                let text = item.text || 'no-text'
                console.log('IMDB: building template', item)

                if (item && item.image && item.image.length > 0) {
  	                $span = $(`<span><img src='${item.image}'/>${text}</span>`);
                } else {
  	                $span = $(`<span>${text}</span>`);
                }
  	            return $span;
            },


            ajax: {
                url: ()=> {
                    return `/imdb/search`
                },
                dataType: 'json',
                processResults: (data)=> {
                    console.log('processResults', data)

                    let results = data.results.results || data.results || data
                    let options = []
                    let items = results && results.results || results
                    for (let e of items) {
                        let text = `${e.title}`
                        options.push({ id: e.id, text: text, img: e.image })
                    }

                    return {
                        results: options
                    }
                }
            },


            placeholder: 'Search for a Film',
            formatNoMatches: 'Search'
        })

        this.el.on('select2:select', (e)=>{
            EventBus.publish('imdb-selected', e.params.data)
        })
    }
}


const instance = new Imdb();
export default instance;
